export default __webpack_public_path__ + "static/media/logo.3d33a45c.svg";